import { useId } from 'react';

const nodes = [
  { label: 'SERVICES', x: 280, y: 86, labelY: 55 },
  { label: 'DOCS', x: 60, y: 222, labelY: 192 },
  { label: 'APIs', x: 500, y: 222, labelY: 192 },
  { label: 'DEPLOY', x: 150, y: 352, labelY: 389 },
  { label: 'INFRA', x: 280, y: 352, labelY: 389 },
  { label: 'OWNERSHIP', x: 420, y: 352, labelY: 389 },
  { label: 'OPERATIONS', x: 280, y: 442, labelY: 476 },
];

export function EngineeringConstellation() {
  const id = useId();
  return (
    <svg
      className="snap-landing__constellation"
      viewBox="0 0 560 510"
      role="img"
      aria-labelledby={`${id}-title ${id}-description`}
    >
      <title id={`${id}-title`}>Backstage IDP engineering constellation</title>
      <desc id={`${id}-description`}>
        Backstage IDP connects services, docs, APIs, deploy, infrastructure,
        ownership, and operations.
      </desc>
      <g fill="none" stroke="#ebc0c8" strokeOpacity=".5" strokeWidth="1.1">
        <path d="M280 86 60 222 150 352 420 352 500 222 280 86M60 222H500M280 86V442M150 352 280 222 420 352" />
      </g>
      <circle
        cx="280"
        cy="222"
        r="77"
        fill="#391225"
        fillOpacity=".88"
        stroke="#dab1bf"
        strokeOpacity=".7"
      />
      <g fill="#fff6f3" textAnchor="middle" fontFamily="inherit">
        <text x="280" y="219" fontSize="24" fontWeight="500">
          BACKSTAGE
        </text>
        <text x="280" y="247" fontSize="20" letterSpacing="3">
          IDP
        </text>
        {nodes.map(node => (
          <g key={node.label}>
            <circle
              cx={node.x}
              cy={node.y}
              r="13"
              fill="#ffcfc4"
              fillOpacity=".12"
            />
            <circle
              cx={node.x}
              cy={node.y}
              r="8"
              fill="#ffcfc4"
              fillOpacity=".1"
            />
            <circle cx={node.x} cy={node.y} r="4.8" fill="#ffddd2" />
            <text x={node.x} y={node.labelY} fontSize="15" letterSpacing="1.1">
              {node.label}
            </text>
          </g>
        ))}
      </g>
    </svg>
  );
}
